import { ClerkProvider } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import './styles/index.css';

// Error tracking only — no tracing/replay, keeps bundle overhead + quota
// near zero. No-ops when the DSN isn't configured (local dev).
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0,
  });
}

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!publishableKey) {
  throw new Error(
    'VITE_CLERK_PUBLISHABLE_KEY is not set — copy apps/dashboard/.env.example to .env and fill it in.',
  );
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('No #root element in index.html');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <BrowserRouter>
      <ClerkProvider
        publishableKey={publishableKey}
        appearance={{
          variables: {
            colorPrimary: '#4C12A1',
            colorBackground: '#1e1645',
            colorText: '#ffffff',
            colorInputBackground: 'rgba(255,255,255,0.08)',
            colorInputText: '#ffffff',
            borderRadius: '10px',
            fontFamily: 'Poppins, sans-serif',
          },
        }}
      >
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ClerkProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
